// see matrix here: https://docs.google.com/presentation/d/1SslbyKMPh1-GUDPqXiEeyiTIjva7K5Wxx0rKQCOGhfw/edit?slide=id.g34d1b29ec8e_1_52#slide=id.g34d1b29ec8e_1_52

export const isShearForceReductionVisible = (
  elementType: ElementTypes,
  materialType: 'steel' | 'timber',
): boolean => {
  const typesForShearForceReduction: ElementTypes[] = [
    'lintels',
    'slab_beams',
    'roof_slab_beams',
    'beams',
    'purlins',
  ]

  return materialType === 'timber' && typesForShearForceReduction.includes(elementType)
}

export const isHotDimensioningVisible = (
  elementType: ElementTypes,
  materialType: 'steel' | 'timber',
): boolean => {
  const typesForHotDimensioning: ElementTypes[] = [
    'slab_beams',
    'roof_slab_beams',
    'beams',
    'purlins',
    'columns',
  ]

  return materialType === 'timber' && typesForHotDimensioning.includes(elementType)
}

export const isVibrationVisible = (
  elementType: ElementTypes,
  materialType: 'steel' | 'timber',
): boolean => {
  const typesForShearForceReduction: ElementTypes[] = ['slab_beams', 'roof_slab_beams']

  return materialType === 'timber' && typesForShearForceReduction.includes(elementType)
}

export const isSteelSupportVisible = (
  elementType: ElementTypes,
  materialType: 'steel' | 'timber',
): boolean => {
  const typesForShearForceReduction: ElementTypes[] = ['rips', 'columns']

  return materialType === 'steel' && typesForShearForceReduction.includes(elementType)
}

export const isTimberSupportVisible = (materialType: 'steel' | 'timber'): boolean => {
  return materialType === 'timber'
}

/** Horizontal and diagonal members of any material can opt out of the static equilibrium check. */
export const isStaticEquilibriumVisible = (elementType: ElementTypes): boolean => {
  const typesForStaticEquilibrium: ElementTypes[] = [
    'lintels',
    'slab_beams',
    'roof_slab_beams',
    'beams',
    'purlins',
  ]

  return typesForStaticEquilibrium.includes(elementType)
}

/** Rips and columns made of timber take an eccentricity of their point loads. */
export const isLoadEccentricityVisible = (
  elementType: ElementTypes,
  materialType: 'steel' | 'timber',
): boolean => {
  const typesForLoadEccentricity: ElementTypes[] = ['rips', 'columns']

  return materialType === 'timber' && typesForLoadEccentricity.includes(elementType)
}
